import React, { useEffect , useState} from "react";


 export const API_URL=`https://www.omdbapi.com/?apikey=${process.env.REACT_APP_API_KEY}`

const AppContext =React.createContext();


const AppProvider=({children})=>{
    const [isLoading, setIsLoading]=useState(true);
    const [movie,setMovie]=useState([]);
    const [isError , setIsError] = useState({show:false,msg:""})
    const [query, setQuery]= useState("titanic");

    const getMovies =async(url)=>{
        try{
            const res = await fetch(url)
            const data = await res.json();
            console.log(data)
            if(data.Response==="True"){
            setIsLoading(false);
            setIsError({
                show:false,
                msg:"",
            });
            setMovie(data.Search);    
            }else{
                setIsError({
                    show:true,
                    msg:data.Error,
                });
            }
        }catch(error){
            console.log(error)
        }
    }

    useEffect(()=>{
        let timeOut = setTimeout(()=>{
            getMovies(`${API_URL}&s=${query}`)
    },550);

    return ()=> clearTimeout(timeOut);
        },[query])
        

    return <AppContext.Provider value={{isLoading,isError,movie ,query, setQuery}}>
    {children}
    </AppContext.Provider>
}//provider hai ye

const useGlobalContext=()=>{
    return React.useContext(AppContext)//consumer ke liye use hota hai use context ye data send krta hai
}

export {AppContext, AppProvider , useGlobalContext}